import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataTaskType } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_TASK_TYPE = defineMasterdataEntity<MasterdataTaskType>({
  name: 'task-type',
  responseKey: 'taskTypes',
  displayWith: (t) => keyName(t.key, t.name),
  icon: 'fa-regular fa-list-check',
  title: 'Aufgabenartsuche',
  label: 'Aufgabenart',
  placeholder: 'Aufgabenart suchen...',
  columns: [
    {
      label: 'Aufgabenart',
      type: 'entity',
      icon: 'fa-regular fa-list-check',
      value: (e) => keyName(e.key, e.name),
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
  ],
});
